var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.tags, function(tag, i) {
      return _c(
        "b-button-group",
        { key: i },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-primary" },
              on: {
                click: function($event) {
                  _vm.removeTag(i)
                }
              }
            },
            [_vm._v(_vm._s(tag))]
          )
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/Tag.vue?vue&type=template&id=7e5182c5&
// module id = null
// module chunks = 